import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { Star, MapPin, ExternalLink, CheckCircle2 } from "lucide-react";

const AdminWorkers = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/workers").then((r) => setItems(r.data.items)).catch(() => {}); }, []);
  const filtered = items.filter((w) =>
    !q || (w.business_name + " " + w.full_name + " " + (w.service_areas || []).join(" ")).toLowerCase().includes(q.toLowerCase())
  );
  return (
    <div>
      <h1 className="font-heading text-3xl font-bold text-[#2D3748]">Workers</h1>
      <p className="text-[#718096] mt-1">All painters on Wazi.</p>
      <input
        data-testid="workers-search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search by name, business, or area…"
        className="mt-6 w-full md:w-96 rounded-xl border border-[#E2E8F0] bg-white px-4 py-2.5 outline-none focus:border-[#25D366]"
      />
      <div className="mt-6 bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F7FAFC] text-[#718096] uppercase tracking-wider text-xs">
            <tr>
              <th className="text-left px-5 py-3">Business</th>
              <th className="text-left px-5 py-3">Areas</th>
              <th className="text-left px-5 py-3">Rating</th>
              <th className="text-left px-5 py-3">Jobs</th>
              <th className="text-right px-5 py-3">Profile</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E2E8F0]">
            {filtered.map((w) => (
              <tr key={w.id} className="hover:bg-[#F7FAFC]" data-testid={`worker-row-${w.slug}`}>
                <td className="px-5 py-4">
                  <div className="flex items-center gap-3">
                    {w.avatar_url ? (
                      <img src={w.avatar_url} alt="" className="w-10 h-10 rounded-full object-cover" />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-[#25D366]/10 text-[#25D366] flex items-center justify-center font-heading font-semibold">
                        {w.business_name?.[0]}
                      </div>
                    )}
                    <div>
                      <div className="font-heading font-semibold text-[#2D3748] flex items-center gap-1.5">
                        {w.business_name}
                        {w.is_verified && <CheckCircle2 className="w-3.5 h-3.5 text-[#1E88E5]" />}
                      </div>
                      <div className="text-xs text-[#718096]">{w.full_name}</div>
                    </div>
                  </div>
                </td>
                <td className="px-5 py-4 text-[#2D3748]">
                  <span className="inline-flex items-center gap-1 text-xs"><MapPin className="w-3 h-3" /> {(w.service_areas || []).slice(0, 3).join(", ")}</span>
                </td>
                <td className="px-5 py-4">
                  <span className="inline-flex items-center gap-1 text-[#2D3748]">
                    <Star className="w-4 h-4 text-[#FFB400] fill-[#FFB400]" />
                    {(w.rating_avg || 0).toFixed(1)}
                    <span className="text-[#718096]"> · {w.reviews_count || 0}</span>
                  </span>
                </td>
                <td className="px-5 py-4 text-[#2D3748]">{w.jobs_completed || 0}</td>
                <td className="px-5 py-4 text-right">
                  <Link to={`/u/${w.slug}`} target="_blank" className="text-[#1E88E5] hover:underline inline-flex items-center gap-1 text-sm">
                    /u/{w.slug} <ExternalLink className="w-3 h-3" />
                  </Link>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={5} className="px-5 py-10 text-center text-[#718096]">No workers found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminWorkers;
